<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>SSS Table</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-text-field
            label="Range"
            :class="classPadding"
            v-model="sss.range"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-text-field
            label="Range 2"
            :class="classPadding"
            v-model="sss.range2"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-text-field
            label="Employer"
            :class="classPadding"
            v-model="sss.employer"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-text-field
            label="Employee"
            :class="classPadding"
            v-model="sss.employee"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-text-field
            label="ECC"
            :class="classPadding"
            v-model="sss.ecc"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-text-field
            label="Total"
            :class="classPadding"
            v-model="sss.total"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-text-field
            label="Bracket"
            :class="classPadding"
            v-model="sss.bracket"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-text-field
            label="MSC"
            :class="classPadding"
            v-model="sss.msc"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="isSaving"
            :class="classPadding"
            @click.stop="save"
            v-if="showSaveButton && userAccess.add >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }" v-if="showSaveButton">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
      <!-- <router-view /> -->
    </v-container>
    <v-dialog v-model="editDialog" width="700" persistent>
      <v-card>
        <v-card-title>
          <span>Edit</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-text-field
                  label="Range"
                  :class="classPadding"
                  v-model="editSSS.range"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-text-field
                  label="Range 2"
                  :class="classPadding"
                  v-model="editSSS.range2"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-text-field
                  label="Employer"
                  :class="classPadding"
                  v-model="editSSS.employer"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-text-field
                  label="Employee"
                  :class="classPadding"
                  v-model="editSSS.employee"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-text-field
                  label="ECC"
                  :class="classPadding"
                  v-model="editSSS.ecc"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-text-field
                  label="Total"
                  :class="classPadding"
                  v-model="editSSS.total"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-text-field
                  label="Bracket"
                  :class="classPadding"
                  v-model="editSSS.bracket"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-text-field
                  label="MSC"
                  :class="classPadding"
                  v-model="editSSS.msc"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="editDialog = false">close</v-btn>
          <v-btn
            text
            @click.stop="update"
            color="success"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./List";
import { mapState, mapActions } from "vuex";
import { isNullOrUndefined } from "../../../../validation/validation";
import isEmpty from "lodash/isEmpty";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/sssTable";
export default {
  metaInfo: {
    title: "SSS Table",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List
  },
  data: () => ({
    classPadding: "my-0 py-0",
    componentKey: 0,
    sss: {},
    isSaving: false,
    editSSS: {},
    editDialog: false,
    isUpdating: false
  }),
  computed: {
    ...mapState("company", {
      companyInfo: state => state.company
    }),
    showSaveButton() {
      if (
        !isNullOrUndefined(this.companyInfo.payrollDB) &&
        !isEmpty(this.companyInfo.payrollDB)
      )
        return true;

      //if (!this.companyInfo.payrollDB) return true;

      return false;
    }
  },
  methods: {
    ...mapActions("company", ["getCompanyInfo"]),
    save() {
      this.$axios
        .post(`${API_ENDPOINT}`, this.sss)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    update() {
      this.isUpdating = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.editSSS)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    reset() {
      this.sss = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    edit(item) {
      this.editSSS = Object.assign({}, item);
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.sssTableNo}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    }
  },
  created() {
    this.getCompanyInfo();

    this.getUserAccessRights("SSSTABLES");
  }
};
</script>
